import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=ad1dbf9e&scoped=true"
import script from "./FileTable.vue?vue&type=script&lang=js"
export * from "./FileTable.vue?vue&type=script&lang=js"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=ad1dbf9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1dbf9e",
  null
  
)

export default component.exports